import { Image, ImageBackground, Modal, StyleSheet, ScrollView, View, Pressable, useWindowDimensions } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FindifyTopBarOverlay } from "../../genericPages/components/FindifyTopBarOverlay";
import { useContext, useEffect, useState } from "react";
import { FindifyDialog } from "../../genericPages/components/FindifyDialog";
import { BasePage } from "../../genericPages/helpers/BasePage";
import React from "react";
import { useTranslation } from "react-i18next";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { FindifySimpleHeader, SimpleHeaderAction } from "../../genericPages/components/FindifySimpleHeader";
import { MakeContentsLine } from "../../genericPages/helpers/ContentSlider";
import { PlaceColors } from "../../genericPages/helpers/PlaceColors";
import { IconShadow } from "../../genericPages/helpers/DefaultShadows";
import { BottomNavigationPadding } from "../../genericPages/components/FindifyNavigation";
import { getTranslatedString } from "../../genericPages/helpers/FindifyTranslatedString";
import { sharePlace, toggleFavouriteWorkspace } from "@/layouts/genericPages/helpers/HompageHelpers";
import { getApiFromModule } from "@/layouts/genericPages/helpers/GetContentsByModule";
import { getFeaturedImageUrl } from "@/layouts/genericPages/helpers/DetailsHelpers";
import { FindifyCMSPage } from "../../genericPages/FindifyCMSPage";
import Icon from "react-native-vector-icons/Ionicons";
import { PlaceText } from "../../genericPages/components/PlaceText";
import Svg, { Circle, Path } from "react-native-svg";
import { useSeoTitle } from "../../genericPages/helpers/SeoTitle";
import { getWorkspaceDescription, getWorkspaceTitle } from "../../genericPages/helpers/WorkspaceText";
import { BiscainhosAppHeader } from "../../genericPages/components/BiscainhosAppHeader";
import { getFileUrl } from "@/config/environment";
import { FindifyHTMLRender } from "../../genericPages/helpers/FindifyHTMLRender";


type PlacePageHeaderArgs = {
    navigation: any,
    enableDonations: boolean,
    enableSharing: boolean,
    enableDownload: boolean,
    enableFavorites: boolean,
    findifyDataContext: FindifyDataContextType | null,
}
export const PlacePageHeader = ({ navigation,
    enableDonations,
    enableSharing,
    enableDownload,
    enableFavorites,
    findifyDataContext,
}: PlacePageHeaderArgs) => {
    const [dialogCode, setDialogCode] = useState<JSX.Element | null>(null);
    const { t } = useTranslation();
    const [actions, setActions] = useState<SimpleHeaderAction[]>([]);
    const insets = useSafeAreaInsets();

    useEffect(() => {
        const actionsList: SimpleHeaderAction[] = [];
        if (enableSharing) {
            actionsList.push({
                icon: 'share-outline',
                action: () => sharePlace(findifyDataContext)
            });
        }
        if (enableFavorites) {
            const alreadyFavourite = findifyDataContext?.favouriteWorkspaces.includes(findifyDataContext?.workspace?.workspace_id);
            actionsList.push({
                color: alreadyFavourite ? "red" : undefined,
                icon: alreadyFavourite ? 'heart' : 'heart-outline',
                action: () => toggleFavouriteWorkspace(findifyDataContext)
            });
        }
        if (enableDownload) {
            actionsList.push({
                icon: 'download-outline',
                action: () => {
                    setDialogCode(<FindifyDialog
                        onAction1={() => { console.log('action1'); setDialogCode(null) }}
                        onAction2={() => { console.log('action2'); setDialogCode(null) }}
                        action1Text={t('popup.yes')}
                        action2Text={t('popup.no')}
                        message="download outline" />);
                }
            });
        }
        if (enableDonations) {
            actionsList.push({
                icon: 'logo-euro',
                action: () => {
                    setDialogCode(<FindifyDialog
                        onAction1={() => { console.log('action1'); setDialogCode(null) }}
                        onAction2={() => { console.log('action2'); setDialogCode(null) }}
                        action1Text={t('popup.yes')}
                        action2Text={t('popup.no')}
                        message="logo outline" />);
                }
            });
        }
        setActions(actionsList);
    }, [findifyDataContext])

    return <FindifySimpleHeader
        navigation={navigation}
        hideGoBack={true}
        image={findifyDataContext?.workspace?.app_settings?.app_banner_url}
        title={getWorkspaceTitle(findifyDataContext)}
        subtitle={getWorkspaceDescription(findifyDataContext)}
        actions={actions}
        changePlaceLeft={true}
    />

}


export const loadContentsLines = async ({
    t,
    findifyDataContext,
    setContentsLines,
    navigation,
     limit }: {
        t: any,
        findifyDataContext: FindifyDataContextType,
        setContentsLines: Function,
        navigation: any,
        limit: number
    }) => {
    const contentsToAdd: any = {};

    let validLines = 0;
    findifyDataContext?.workspace?.app_settings?.homepage_lines?.map((line: any, index: number) => {
        if (line.module && line.module !== '') {
            validLines++;
            const api = getApiFromModule(line.module, findifyDataContext);
            let orderby = {};
            let filters = {};

            line.title = t('modules.content_types.' + line.module);
            if (line.category && line.category !== '') {
                line.title = undefined;
                filters = { 'categories.category.category_id': +line.category }
            }

            api?.getList(0, limit, null, filters, orderby).then(async (res: any) => {
                console.log('res', res, line)
                const lineItems = res.results.map((item: any) => {
                    if (line.title === undefined) {
                        // Filter cat to get the title
                        const cat = item.categories.find((cat: any) => cat.category_id === +line.category);
                        line.title = getTranslatedString(cat?.category?.name, findifyDataContext);
                    }
                    return {
                        ...item,
                        // title: item.name,
                        image: getFeaturedImageUrl(item),
                        subtitle: '',
                        action: () => {
                            navigation.push('PlaceContentDetails', {
                                module: line.module,
                                content_id: item.content_id,
                                page_slug: item.page_slug
                            })
                        }
                    }
                });
                contentsToAdd[index] = {
                    ...line,
                    title: line.title,
                    items: lineItems,
                }

                if (Object.keys(contentsToAdd).length === validLines) {
                    setContentsLines(contentsToAdd);
                }
            })
        }
    })
}

const stripHtml = (html: string) => {
    return (html ?? '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/\s+\n/g, '\n')
        .replace(/\n\s+/g, '\n')
        .trim();
}

const getHomepageEntryParams = (findifyDataContext: FindifyDataContextType | null) => {
    return findifyDataContext?.workspace?.app_settings?.homepage_lines?.[0] ?? {
        module: 'contents',
        category: '105',
        columns: '1',
    };
}

const WheelchairIcon = ({ size = 56, color = '#b90000' }: { size?: number, color?: string }) => {
    return <Svg width={size} height={size} viewBox="0 0 64 64">
        <Circle cx="25" cy="13" r="6" fill={color} />
        <Path
            d="M24 22 L27 36 H43 L50 50"
            fill="none"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <Path
            d="M30 25 H43"
            fill="none"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
        />
        <Circle
            cx="28"
            cy="45"
            r="13"
            fill="none"
            stroke={color}
            strokeWidth="6"
        />
        <Path
            d="M45 50 H55"
            fill="none"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
        />
    </Svg>
}

const languageLabels: Record<string, string> = {
    'pt-PT': 'Português',
    'en-US': 'English',
    'en-GB': 'English',
}

const isEnglishLanguage = (language?: string) => language?.startsWith('en');
const localizedText = (findifyDataContext: FindifyDataContextType | null, pt: string, en: string) => (
    isEnglishLanguage(findifyDataContext?.language) ? en : pt
);

const findWorkspaceMenuItem = (findifyDataContext: FindifyDataContextType | null, labelPt: string, fallback: any) => {
    const normalizedLabel = labelPt.trim().toLowerCase();
    return findifyDataContext?.workspace?.app_settings?.app_menu_lines?.find((item: any) => (
        getTranslatedString(item?.label, findifyDataContext as FindifyDataContextType)?.trim().toLowerCase() === normalizedLabel
        || item?.label?.['pt-PT']?.trim?.().toLowerCase() === normalizedLabel
    )) ?? fallback;
}

const openWorkspaceMenuItem = (item: any, navigation: any) => {
    switch (item?.type) {
        case 'content':
            navigation.push('PlaceContentDetails', {
                module: 'contents',
                content_id: item.content_id,
            });
            break;
        case 'contents':
            navigation.push('PlaceContentList', {
                module: item.content_type,
                category: item.content_category,
            });
            break;
        case 'url':
            if (item?.url?.toLowerCase?.().includes('plants')) {
                navigation.push('PlantsPage');
                break;
            }
            navigation.push('WebViewPage', { url: item.url, title: item.label });
            break;
        case 'module':
            if (item.module === 'scan_qr') {
                navigation.push('ScanQR');
                break;
            }
            if (item.module === 'info') {
                navigation.push('PlaceInfo');
                break;
            }
            navigation.push('Place');
            break;
        default:
            break;
    }
}

const BiscainhosLanguageScreen = ({
    findifyDataContext,
    onSelectLanguage,
}: {
    findifyDataContext: FindifyDataContextType | null,
    onSelectLanguage: (language: string) => void,
}) => {
    useSeoTitle(localizedText(findifyDataContext, 'Selecionar idioma', 'Select language'), getWorkspaceTitle(findifyDataContext));
    const { width } = useWindowDimensions();
    const isTablet = width >= 768;
    const logo = findifyDataContext?.workspace?.app_settings?.app_logo_url;
    const banner = findifyDataContext?.workspace?.app_settings?.app_banner_url;
    const colors = PlaceColors(findifyDataContext);
    const languages = (findifyDataContext?.workspace?.languages ?? [])
        .map((item: any) => item?.language)
        .filter(Boolean)
        .filter((language: any) => ['pt-PT', 'en-US', 'en-GB'].includes(language?.tag))
        .sort((a: any, b: any) => (a.tag === 'pt-PT' ? -1 : b.tag === 'pt-PT' ? 1 : 0));

    const availableLanguages = languages.length > 0 ? languages : [
        { tag: 'pt-PT', local: 'Português' },
        { tag: 'en-US', local: 'English' },
    ];

    return <View style={[
        styles.languagePage,
        {
            backgroundColor: colors.background.get(),
            borderLeftColor: colors.primary.get(),
            borderRightColor: colors.secondary.get(),
        }
    ]}>
        <ImageBackground
            source={banner ? { uri: banner } : undefined}
            resizeMode="cover"
            style={styles.languageBackground}>
            <View style={[styles.languageImageOverlay, { backgroundColor: colors.background.withAlpha(235) }]} />
            <View style={styles.languagePattern}>
                {Array.from({ length: 18 }).map((_, index) => (
                    <View
                        key={`language_pattern_${index}`}
                        style={[
                            styles.languagePatternDot,
                            {
                                backgroundColor: colors.secondary.withAlpha(45),
                                left: `${(index * 29) % 100}%` as any,
                                top: `${(index * 47) % 100}%` as any,
                            }
                        ]}
                    />
                ))}
            </View>
            <View style={styles.languagePaper}>
                <ScrollView
                    bounces={false}
                    showsVerticalScrollIndicator={false}
                    contentContainerStyle={[
                        styles.languageContent,
                        isTablet ? styles.languageContentTablet : null,
                    ]}>
                    <View style={styles.languageTop}>
                        {logo ? <Image source={{ uri: logo }} resizeMode="contain" style={styles.languageLogo} /> : null}
                    </View>

                    <View style={styles.languageWelcome}>
                        <PlaceText style={[styles.languageTitle, { color: colors.primary.get() }]}>Bem-vindo</PlaceText>
                        <PlaceText style={[styles.languageSubtitle, { color: colors.secondary.solidAlphaBlackBase(45) }]}>Welcome</PlaceText>
                        <View style={[styles.languageDivider, { backgroundColor: colors.secondary.get() }]} />
                    </View>

                    <View style={styles.languageActions}>
                        <PlaceText style={[styles.languagePrompt, { color: colors.text.withAlpha(190) }]}>SELECIONE O IDIOMA / SELECT LANGUAGE</PlaceText>
                        {availableLanguages.map((language: any, index: number) => {
                            const isPrimary = language.tag === 'pt-PT' || index === 0;
                            return <Pressable
                                key={language.tag}
                                style={[
                                    styles.languageButton,
                                    isPrimary ? [
                                        styles.languageButtonPrimary,
                                        { backgroundColor: colors.primary.get() }
                                    ] : [
                                        styles.languageButtonSecondary,
                                        {
                                            backgroundColor: colors.background.solidAlphaWhiteBase(90),
                                            borderColor: colors.secondary.get(),
                                        }
                                    ]
                                ]}
                                onPress={() => onSelectLanguage(language.tag)}>
                                <PlaceText style={[
                                    styles.languageButtonText,
                                    isPrimary ? styles.languageButtonTextPrimary : [
                                        styles.languageButtonTextSecondary,
                                        { color: colors.primary.get() }
                                    ]
                                ]}>
                                    {languageLabels[language.tag] ?? language.local}
                                </PlaceText>
                                <Icon name="chevron-forward" size={30} color={colors.secondary.get()} />
                            </Pressable>
                        })}
                    </View>

                    <View style={styles.languageFooter}>
                        <PlaceText style={[styles.languageLocation, { color: colors.text.withAlpha(190) }]}>{getWorkspaceTitle(findifyDataContext)}</PlaceText>
                        <View style={styles.languageFooterIcons}>
                            <Icon name="walk" size={30} color={colors.secondary.solidAlphaBlackBase(55)} />
                            <Icon name="volume-high-outline" size={30} color={colors.secondary.solidAlphaBlackBase(55)} />
                        </View>
                    </View>
                </ScrollView>
            </View>
        </ImageBackground>
    </View>
}

const getTimelineMediaUrl = (media: any) => (
    media?.file_url_path || media?.file_url || media?.url || (media?.file_path ? `${getFileUrl()}${media.file_path}` : undefined)
);

const TimelineFeaturedImage = ({ uri }: { uri: string }) => {
    const [aspectRatio, setAspectRatio] = useState<number | undefined>();
    useEffect(() => {
        Image.getSize(uri, (width, height) => {
            if (width > 0 && height > 0) setAspectRatio(width / height);
        });
    }, [uri]);

    return <Image
        source={{ uri }}
        resizeMode="contain"
        style={[styles.timelineFeaturedImage, aspectRatio ? { aspectRatio } : styles.timelineFeaturedImageLoading]}
    />;
}

const TimelineHomePage = ({ navigation, findifyDataContext }: { navigation: any, findifyDataContext: FindifyDataContextType | null }) => {
    const [timelineTitle, setTimelineTitle] = useState('');
    const [timelineItems, setTimelineItems] = useState<any[]>([]);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [hideTimelineDates, setHideTimelineDates] = useState(false);
    const { width } = useWindowDimensions();
    const isTablet = width >= 768;
    const colors = PlaceColors(findifyDataContext);
    useSeoTitle(getWorkspaceTitle(findifyDataContext), localizedText(findifyDataContext, 'Cronograma', 'Timeline'));

    useEffect(() => {
        let mounted = true;
        const categoriesApi = getApiFromModule('categories', findifyDataContext as FindifyDataContextType);
        const contentsApi = getApiFromModule('contents', findifyDataContext as FindifyDataContextType);
        categoriesApi?.getList(0, 300, null, { category_type: 'contents', active: 1 }, null)
            .then((categoriesData: any) => {
                const category = (categoriesData?.results ?? []).find((item: any) => item?.page_slug === 'cronograma');
                if (!category) return [];
                if (mounted) {
                    setTimelineTitle(getTranslatedString(category.name, findifyDataContext as FindifyDataContextType));
                    setHideTimelineDates(category.hide_date_on_details === true || category.hide_date_on_details === 1 || category.hide_date_on_details === '1');
                }
                return contentsApi?.getList(0, 300, null, { 'categories.category.category_id': category.category_id }, null)
                    .then((contentsData: any) => contentsData?.results ?? []);
            })
            .then((items: any[]) => {
                if (!mounted || !items) return;
                setTimelineItems(items.slice().sort((a: any, b: any) => {
                    const aDate = new Date(a.public_date ?? a.created_at ?? 0).valueOf();
                    const bDate = new Date(b.public_date ?? b.created_at ?? 0).valueOf();
                    return aDate - bDate || Number(a.content_id) - Number(b.content_id);
                }));
            })
            .catch((error: any) => console.error('Failed to load timeline:', error));
        return () => { mounted = false; };
    }, [findifyDataContext?.workspace?.workspace_id, findifyDataContext?.language]);

    const getImages = (item: any) => Array.from(new Set([
        getFeaturedImageUrl(item),
        ...(item?.galleries ?? []).map((gallery: any) => getTimelineMediaUrl(gallery?.image_media)),
    ].filter(Boolean))) as string[];
    const openItem = (item: any) => setSelectedItem(item);
    const selectedImages = selectedItem ? getImages(selectedItem) : [];

    return <View style={[styles.timelinePage, { backgroundColor: colors.background.get() }]}>
        <BiscainhosAppHeader navigation={navigation} findifyDataContext={findifyDataContext} allowBackFallback={false} />
        <ScrollView bounces={false} showsVerticalScrollIndicator={false} contentContainerStyle={styles.timelineScroll}>
            <View style={styles.timelineHero}>
                <PlaceText style={[styles.timelineEyebrow, { color: colors.secondary.get() }]}>{getWorkspaceTitle(findifyDataContext)}</PlaceText>
                <PlaceText style={[styles.timelineTitle, { color: colors.primary.get() }]}>{timelineTitle || localizedText(findifyDataContext, 'Cronograma', 'Timeline')}</PlaceText>
                <PlaceText style={[styles.timelineLead, { color: colors.text.withAlpha(205) }]}>{localizedText(findifyDataContext, 'Uma viagem visual pela história do Museu', 'A visual journey through the Museum history')}</PlaceText>
            </View>
            <View style={[styles.timelineTrack, isTablet ? styles.timelineTrackTablet : null]}>
                {timelineItems.map((item: any, index: number) => {
                    const images = getImages(item);
                    const date = new Date(item.public_date ?? item.created_at);
                    const dateLabel = Number.isNaN(date.valueOf()) ? '' : date.toLocaleDateString(findifyDataContext?.language ?? 'pt-PT', { year: 'numeric', month: 'long', day: 'numeric' });
                    return <View key={`timeline_${item.content_id}`} style={[styles.timelineEntry, isTablet && index % 2 === 1 ? styles.timelineEntryReverse : null]}>
                        <View style={styles.timelineRail}><View style={[styles.timelineDot, { backgroundColor: colors.secondary.get(), borderColor: colors.background.get() }]} /></View>
                        <View style={[styles.timelineCard, { backgroundColor: colors.background.solidAlphaWhiteBase(82), borderColor: colors.primary.withAlpha(38) }]}>
                            <Pressable onPress={() => openItem(item)}>
                                {images[0] ? <TimelineFeaturedImage uri={images[0]} /> : <View style={[styles.timelineImageFallback, { backgroundColor: colors.primary.withAlpha(25) }]}><Icon name="images-outline" size={44} color={colors.primary.get()} /></View>}
                                <View style={[styles.timelineImageShade, { backgroundColor: colors.primary.withAlpha(55) }]} />
                                <View style={styles.timelineImageHint}><Icon name="expand-outline" size={20} color="#fff" /></View>
                            </Pressable>
                            <View style={styles.timelineCardBody}>
                                {!hideTimelineDates && !!dateLabel && <PlaceText style={[styles.timelineDate, { color: colors.secondary.get() }]}>{dateLabel}</PlaceText>}
                                <PlaceText style={[styles.timelineItemTitle, { color: colors.primary.get() }]}>{getTranslatedString(item.name, findifyDataContext as FindifyDataContextType)}</PlaceText>
                                <PlaceText style={[styles.timelineResume, { color: colors.text.withAlpha(210) }]}>{stripHtml(getTranslatedString(item.resume, findifyDataContext as FindifyDataContextType))}</PlaceText>
                                {images.length > 1 ? <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.timelineGallery}>
                                    {images.slice(1).map((image, imageIndex) => <Pressable key={`${item.content_id}_gallery_${imageIndex}`} onPress={() => openItem(item)}><Image source={{ uri: image }} resizeMode="cover" style={styles.timelineGalleryImage} /></Pressable>)}
                                </ScrollView> : null}
                            </View>
                        </View>
                    </View>
                })}
            </View>
            <PlaceText style={[styles.copyright, { color: colors.text.withAlpha(145) }]}>{localizedText(findifyDataContext, `© ${getWorkspaceTitle(findifyDataContext)}. Todos os direitos reservados.`, `© ${getWorkspaceTitle(findifyDataContext)}. All rights reserved.`)}</PlaceText>
        </ScrollView>
        <Modal visible={!!selectedItem} animationType="fade" transparent={true} onRequestClose={() => setSelectedItem(null)}>
            <View style={styles.timelineModalBackdrop}>
                <View style={[styles.timelineModalCard, { backgroundColor: colors.background.get() }]}>
                    <Pressable style={[styles.timelineModalClose, { backgroundColor: colors.primary.get() }]} onPress={() => setSelectedItem(null)}><Icon name="close" size={26} color="#fff" /></Pressable>
                    <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={styles.timelineModalContent}>
                        <PlaceText style={[styles.timelineItemTitle, { color: colors.primary.get() }]}>{getTranslatedString(selectedItem?.name, findifyDataContext as FindifyDataContextType)}</PlaceText>
                        <PlaceText style={[styles.timelineResume, { color: colors.text.get() }]}>{stripHtml(getTranslatedString(selectedItem?.resume, findifyDataContext as FindifyDataContextType))}</PlaceText>
                        {selectedImages.map((image, index) => <Image key={`modal_timeline_${index}`} source={{ uri: image }} resizeMode="contain" style={styles.timelineModalImage} />)}
                        {!!selectedItem?.description && <View style={styles.timelineModalDescription}>
                            <FindifyHTMLRender
                                baseStyles={{ color: colors.text.get(), fontSize: 16, lineHeight: 25 }}
                                htmlCode={getTranslatedString(selectedItem.description, findifyDataContext as FindifyDataContextType)}
                            />
                        </View>}
                    </ScrollView>
                </View>
            </View>
        </Modal>
    </View>
}

const BiscainhosHomePage = ({
    navigation,
    findifyDataContext,
}: {
    navigation: any,
    findifyDataContext: FindifyDataContextType | null,
}) => {
    const [welcomeContent, setWelcomeContent] = useState<any>(null);
    useSeoTitle(getWorkspaceTitle(findifyDataContext), localizedText(findifyDataContext, 'Início', 'Home'));
    const { width, height } = useWindowDimensions();
    const isTablet = width >= 768;
    const isLandscapeTablet = isTablet && width > height;

    useEffect(() => {
        const api = getApiFromModule('contents', findifyDataContext as FindifyDataContextType);
        api?.get(788, null, null).then((res: any) => {
            setWelcomeContent(res);
        }).catch((error: any) => {
            console.error('Failed to load Dom Diogo de Sousa welcome content:', error);
        });
    }, [findifyDataContext?.workspace?.workspace_id]);

    const title = getTranslatedString(welcomeContent?.name, findifyDataContext as FindifyDataContextType)
        || localizedText(findifyDataContext, 'Bem-vindo', 'Welcome');
    const description = stripHtml(
        getTranslatedString(welcomeContent?.description, findifyDataContext as FindifyDataContextType)
            || getTranslatedString(welcomeContent?.resume, findifyDataContext as FindifyDataContextType)
    ) || getWorkspaceDescription(findifyDataContext);
    const image = getFeaturedImageUrl(welcomeContent) || findifyDataContext?.workspace?.app_settings?.app_banner_url;
    const colors = PlaceColors(findifyDataContext);
    const museumMenuItem = findWorkspaceMenuItem(findifyDataContext, 'O Museu', {
        type: 'content',
        content_id: 791,
    });
    const visitMenuItem = findWorkspaceMenuItem(findifyDataContext, 'Visita', {
        type: 'url',
        url: 'plants',
    });
    const roomsMenuItem = findWorkspaceMenuItem(findifyDataContext, 'Salas', {
        type: 'contents',
        content_type: 'points_of_interest',
    });
    const reviewMenuItem = findWorkspaceMenuItem(findifyDataContext, 'Avaliação', {
        type: 'content',
        content_id: 796,
    });
    const homeActions = [
        {
            title: localizedText(findifyDataContext, 'O Museu', 'The Museum'),
            subtitle: localizedText(findifyDataContext, 'História, coleção e contexto da visita', 'History, collection and visit context'),
            icon: 'business-outline',
            tint: colors.primary.get(),
            action: () => openWorkspaceMenuItem(museumMenuItem, navigation),
        },
        {
            title: localizedText(findifyDataContext, 'Visita', 'Visit'),
            subtitle: localizedText(findifyDataContext, 'Percurso guiado pelos pisos do museu', 'Guided route through the museum floors'),
            icon: 'map-outline',
            tint: colors.secondary.get(),
            action: () => openWorkspaceMenuItem(visitMenuItem, navigation),
        },
        {
            title: localizedText(findifyDataContext, 'Salas', 'Rooms'),
            subtitle: localizedText(findifyDataContext, 'Pisos, salas, núcleos e peças', 'Floors, rooms, sections and objects'),
            icon: 'grid-outline',
            tint: colors.primary.solidAlphaBlackBase(35),
            action: () => openWorkspaceMenuItem(roomsMenuItem, navigation),
        },
        {
            title: localizedText(findifyDataContext, 'Avaliação', 'Review'),
            subtitle: localizedText(findifyDataContext, 'Partilhe a sua opinião sobre a experiência', 'Share your opinion about the experience'),
            icon: 'happy-outline',
            tint: colors.secondary.solidAlphaBlackBase(35),
            action: () => openWorkspaceMenuItem(reviewMenuItem, navigation),
        },
    ];

    return <View style={[styles.biscainhosPage, { backgroundColor: colors.background.get() }]}>
        <ImageBackground
            source={image ? { uri: image } : undefined}
            resizeMode="cover"
            style={styles.biscainhosBackground}>
            <View style={[styles.biscainhosScrim, { backgroundColor: colors.background.withAlpha(218) }]} />
            <View style={styles.homePattern}>
                {Array.from({ length: 22 }).map((_, index) => (
                    <View
                        key={`home_pattern_${index}`}
                        style={[
                            styles.homePatternMark,
                            {
                                borderColor: index % 2 === 0 ? colors.primary.withAlpha(42) : colors.secondary.withAlpha(48),
                                left: `${(index * 37) % 100}%` as any,
                                top: `${(index * 23) % 100}%` as any,
                            }
                        ]}
                    />
                ))}
            </View>
            <View style={styles.biscainhosVersionLayer}>
                    <BiscainhosAppHeader
                        navigation={navigation}
                        findifyDataContext={findifyDataContext}
                        allowBackFallback={false}
                    />
                    <ScrollView
                        bounces={false}
                        showsVerticalScrollIndicator={false}
                        style={styles.biscainhosScroll}
                        contentContainerStyle={[
                            styles.biscainhosContent,
                            isTablet ? styles.biscainhosContentTablet : null,
                        ]}>
                        <View style={[
                            styles.biscainhosIntro,
                            isLandscapeTablet ? styles.biscainhosIntroLandscapeTablet : null,
                        ]}>
                            <PlaceText style={[styles.biscainhosTitle, { color: colors.primary.get() }]}>{getWorkspaceTitle(findifyDataContext)}</PlaceText>
                            <PlaceText style={[styles.biscainhosDescription, { color: colors.text.withAlpha(220) }]}>{description || title}</PlaceText>
                        </View>

                        <View style={[
                            styles.versionCardsGrid,
                            isLandscapeTablet ? styles.versionCardsGridLandscapeTablet : null,
                        ]}>
                            {homeActions.map((item, index) => (
                                <Pressable
                                    key={`mdds_home_action_${item.title}`}
                                    style={[
                                        styles.versionCard,
                                        index === 0 ? styles.homeActionFeatured : null,
                                        {
                                            borderColor: item.tint + '55',
                                            backgroundColor: colors.background.withAlpha(232),
                                        }
                                    ]}
                                    onPress={item.action}>
                                    <View style={[styles.homeActionIcon, { backgroundColor: item.tint + '22', borderColor: item.tint + '55' }]}>
                                        <Icon name={item.icon as any} size={30} color={item.tint} />
                                    </View>
                                    <View style={styles.versionCardCopy}>
                                        <PlaceText style={[styles.versionTitle, { color: colors.primary.get() }]}>{item.title}</PlaceText>
                                        <PlaceText style={[styles.versionCopy, { color: colors.text.withAlpha(178) }]}>{item.subtitle}</PlaceText>
                                    </View>
                                    <View style={[styles.homeActionArrow, { backgroundColor: item.tint }]}>
                                        <Icon name="arrow-forward-outline" size={22} color={colors.background.get()} />
                                    </View>
                                </Pressable>
                            ))}
                        </View>

                        <PlaceText style={[styles.copyright, { color: colors.text.withAlpha(145) }]}>{localizedText(findifyDataContext, `© ${getWorkspaceTitle(findifyDataContext)}. Todos os direitos reservados.`, `© ${getWorkspaceTitle(findifyDataContext)}. All rights reserved.`)}</PlaceText>
                </ScrollView>
            </View>
        </ImageBackground>
    </View>
}

export const PlaceTab = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();
    const { t, i18n } = useTranslation();
    const findifyDataContext = useContext(FindifyDataContext);
    const [contentsLines, setContentsLines] = useState<any[]>([]);
    const [languageSelected, setLanguageSelected] = useState(false);

    useEffect(() => {
        loadContentsLines({ t, findifyDataContext, setContentsLines, navigation, limit: 6 });
    }, []);

    if (findifyDataContext?.workspace?.workspace_id === 156 && !languageSelected) {
        return <BasePage navigation={navigation} hideBottomNavigation={true}>
            <BiscainhosLanguageScreen
                findifyDataContext={findifyDataContext}
                onSelectLanguage={(language: string) => {
                    findifyDataContext?.setLanguage(language);
                    i18n.changeLanguage(language);
                    setLanguageSelected(true);
                }}
            />
        </BasePage>
    }

    if (findifyDataContext?.workspace?.workspace_id === 156) {
        return <BasePage navigation={navigation}>
            <TimelineHomePage
                navigation={navigation}
                findifyDataContext={findifyDataContext}
            />
        </BasePage>
    }

    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <ScrollView
            bounces={false}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            style={{ paddingBottom: insets.bottom + BottomNavigationPadding }}>
            <View style={{
                paddingBottom: insets.bottom + BottomNavigationPadding,
                backgroundColor: PlaceColors(findifyDataContext).background.get(),

            }}>
                <PlacePageHeader
                    enableDonations={false}
                    enableSharing={true}
                    enableDownload={false}
                    enableFavorites={true}
                    navigation={navigation}
                    findifyDataContext={findifyDataContext}
                />
                {findifyDataContext?.workspace?.app_settings?.homepage_id ? (
                    <FindifyCMSPage 
                        pageId={findifyDataContext.workspace.app_settings.homepage_id} 
                        navigation={navigation} 
                    />
                ) : (
                    contentsLines && Object.keys(contentsLines).map((index: string) => {
                        const line = contentsLines[parseInt(index)];
                        return <MakeContentsLine
                            key={"contents_line_" + index}
                            language={findifyDataContext?.language ?? ''}
                            title={line.title}
                            lIndex={+index}
                            module={line.module}
                            contents={line.items}
                            viewAllAction={() => {
                                navigation.push('PlaceContentList', findifyDataContext?.workspace.app_settings?.homepage_lines[index])
                            }}
                        />
                    })
                )}
            </View>
        </ScrollView>
    </BasePage>;
};


const styles = StyleSheet.create({
    timelinePage: { flex: 1, minHeight: '100dvh' as any },
    timelineScroll: { paddingBottom: BottomNavigationPadding + 38 },
    timelineHero: { paddingHorizontal: 26, paddingTop: 48, paddingBottom: 32, alignItems: 'center' },
    timelineEyebrow: { fontSize: 12, lineHeight: 18, fontWeight: '700', letterSpacing: 2.6, textTransform: 'uppercase', textAlign: 'center' },
    timelineTitle: { marginTop: 10, fontFamily: 'Georgia', fontSize: 38, lineHeight: 45, fontWeight: '700', textAlign: 'center' },
    timelineLead: { marginTop: 12, maxWidth: 440, fontSize: 16, lineHeight: 24, textAlign: 'center' },
    timelineTrack: { paddingHorizontal: 20, paddingBottom: 12 },
    timelineTrackTablet: { width: '100%', maxWidth: 1020, alignSelf: 'center', paddingHorizontal: 48 },
    timelineEntry: { flexDirection: 'row', alignItems: 'stretch', minHeight: 230 },
    timelineEntryReverse: { flexDirection: 'row-reverse' },
    timelineRail: { width: 32, alignItems: 'center', borderLeftWidth: 1, borderLeftColor: 'rgba(150,112,54,0.28)', marginLeft: 15 },
    timelineDot: { position: 'absolute', top: 28, width: 16, height: 16, borderRadius: 8, borderWidth: 4, zIndex: 2 },
    timelineCard: { flex: 1, borderWidth: 1, borderRadius: 14, overflow: 'hidden', marginBottom: 26, shadowColor: '#241716', shadowOpacity: 0.12, shadowRadius: 12, shadowOffset: { width: 0, height: 5 } },
    timelineFeaturedImage: { width: '100%', backgroundColor: 'rgba(58,42,40,0.06)' },
    timelineFeaturedImageLoading: { aspectRatio: 1.35 },
    timelineImageFallback: { width: '100%', height: 210, alignItems: 'center', justifyContent: 'center' },
    timelineImageShade: { ...StyleSheet.absoluteFillObject, bottom: undefined, height: 56 },
    timelineImageHint: { position: 'absolute', top: 12, right: 12, width: 36, height: 36, borderRadius: 18, alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.42)' },
    timelineCardBody: { padding: 18 },
    timelineDate: { fontSize: 12, lineHeight: 18, fontWeight: '700', letterSpacing: 1.2, textTransform: 'uppercase' },
    timelineItemTitle: { marginTop: 5, fontFamily: 'Georgia', fontSize: 25, lineHeight: 31, fontWeight: '700' },
    timelineResume: { marginTop: 9, fontSize: 16, lineHeight: 23 },
    timelineGallery: { gap: 8, marginTop: 16, paddingRight: 2 },
    timelineGalleryImage: { width: 86, height: 66, borderRadius: 7 },
    timelineModalBackdrop: { flex: 1, padding: 18, backgroundColor: 'rgba(15,10,8,0.83)', justifyContent: 'center' },
    timelineModalCard: { maxHeight: '88%', borderRadius: 16, overflow: 'hidden' },
    timelineModalClose: { position: 'absolute', zIndex: 3, right: 12, top: 12, width: 40, height: 40, borderRadius: 20, alignItems: 'center', justifyContent: 'center' },
    timelineModalContent: { padding: 24, paddingTop: 30 },
    timelineModalImage: { width: '100%', height: 280, marginTop: 18, borderRadius: 8, backgroundColor: '#1f120f' },
    timelineModalDescription: { marginTop: 18, fontSize: 16, lineHeight: 25 },
    container: {
        flex: 1,
    },
    headerIcon: {
        padding: 5,
        ...IconShadow,
    },
    languagePage: {
        flex: 1,
        minHeight: '100dvh' as any,
        width: '100%',
        borderLeftWidth: 4,
        borderRightWidth: 3,
    },
    languageBackground: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
    languageImageOverlay: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
    languagePattern: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        opacity: 0.55,
    },
    languagePatternDot: {
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
    },
    languagePaper: {
        flex: 1,
    },
    languageContent: {
        minHeight: '100dvh' as any,
        paddingHorizontal: 28,
        paddingTop: 74,
        paddingBottom: 52,
        justifyContent: 'space-between',
    },
    languageContentTablet: {
        width: '100%',
        maxWidth: 620,
        alignSelf: 'center',
        paddingTop: 96,
        paddingBottom: 72,
    },
    languageTop: {
        alignItems: 'center',
    },
    languageLogo: {
        width: '72%',
        maxWidth: 420,
        height: 78,
    },
    languageWelcome: {
        alignItems: 'center',
        marginTop: 34,
    },
    languageTitle: {
        fontFamily: 'Georgia',
        fontSize: 32,
        lineHeight: 40,
        fontWeight: '700',
        textAlign: 'center',
    },
    languageSubtitle: {
        marginTop: 8,
        fontFamily: 'Georgia',
        fontSize: 27,
        lineHeight: 34,
        fontWeight: '700',
        fontStyle: 'italic',
        textAlign: 'center',
    },
    languageDivider: {
        marginTop: 22,
        width: 64,
        height: 1,
    },
    languageActions: {
        width: '100%',
        maxWidth: 430,
        alignSelf: 'center',
        marginTop: 42,
    },
    languagePrompt: {
        fontSize: 13,
        lineHeight: 20,
        letterSpacing: 2.2,
        textAlign: 'center',
        marginBottom: 18,
        fontWeight: '600',
    },
    languageButton: {
        height: 72,
        borderRadius: 8,
        marginBottom: 16,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        overflow: 'hidden',
    },
    languageButtonPrimary: {
        shadowColor: '#000',
        shadowOpacity: 0.18,
        shadowRadius: 10,
        shadowOffset: { width: 0, height: 4 },
    },
    languageButtonSecondary: {
        borderWidth: 1,
    },
    languageButtonText: {
        fontFamily: 'Georgia',
        fontSize: 25,
        lineHeight: 32,
        textAlign: 'center',
    },
    languageButtonTextPrimary: {
        color: '#fff',
        fontWeight: '700',
    },
    languageButtonTextSecondary: {},
    languageFooter: {
        marginTop: 48,
        alignItems: 'center',
    },
    languageLocation: {
        fontSize: 13,
        lineHeight: 18,
        textAlign: 'center',
    },
    languageFooterIcons: {
        marginTop: 14,
        flexDirection: 'row',
        gap: 26,
        alignItems: 'center',
        justifyContent: 'center',
    },
    biscainhosPage: {
        flex: 1,
        minHeight: '100dvh' as any,
        width: '100%',
    },
    biscainhosBackground: {
        flex: 1,
        width: '100%',
        minHeight: '100dvh' as any,
    },
    biscainhosScrim: {
        ...StyleSheet.absoluteFillObject,
    },
    homePattern: {
        ...StyleSheet.absoluteFillObject,
        opacity: 0.78,
    },
    homePatternMark: {
        position: 'absolute',
        width: 46,
        height: 46,
        borderRadius: 23,
        borderWidth: 1,
    },
    biscainhosVersionLayer: {
        flex: 1,
        minHeight: '100dvh' as any,
    },
    versionCardsGrid: {
        width: '100%',
        maxWidth: 720,
        alignSelf: 'center',
        gap: 14,
    },
    versionCardsGridLandscapeTablet: {
        maxWidth: 1040,
        flexDirection: 'row',
        alignItems: 'stretch',
        flexWrap: 'wrap',
    },
    biscainhosScroll: {
        flex: 1,
        minHeight: '100dvh' as any,
    },
    biscainhosContent: {
        minHeight: '100dvh' as any,
        paddingHorizontal: 24,
        paddingTop: 28,
        paddingBottom: BottomNavigationPadding + 34,
    },
    biscainhosContentTablet: {
        paddingHorizontal: 40,
    },
    biscainhosTop: {
        minHeight: 80,
        marginHorizontal: -24,
        paddingHorizontal: 24,
        paddingTop: 12,
        paddingBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(226, 177, 60, 0.65)',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(229, 235, 226, 0.46)',
        backdropFilter: 'blur(8px)' as any,
    },
    biscainhosLogo: {
        width: 190,
        height: 52,
    },
    biscainhosEyeButton: {
        width: 60,
        height: 60,
        borderWidth: 1.5,
        borderColor: '#e2b13c',
        borderRadius: 15,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(30, 85, 95, 0.52)',
    },
    biscainhosIntro: {
        alignItems: 'flex-start',
        width: '100%',
        maxWidth: 720,
        alignSelf: 'center',
        paddingTop: 14,
        paddingBottom: 22,
    },
    biscainhosIntroLandscapeTablet: {
        maxWidth: 1040,
    },
    biscainhosTitle: {
        fontSize: 34,
        lineHeight: 42,
        fontFamily: 'Georgia',
        fontWeight: '700',
        textAlign: 'left',
    },
    biscainhosSubtitle: {
        marginTop: 2,
        color: '#e2b13c',
        fontSize: 36,
        lineHeight: 42,
        fontFamily: 'Georgia',
        fontWeight: '700',
        letterSpacing: 7,
        textAlign: 'center',
    },
    biscainhosDescription: {
        marginTop: 12,
        maxWidth: 660,
        fontSize: 16,
        lineHeight: 24,
        textAlign: 'left',
    },
    biscainhosDescriptionItalic: {
        marginTop: 8,
        maxWidth: 520,
        color: 'rgba(255,255,255,0.72)',
        fontSize: 28,
        lineHeight: 44,
        textAlign: 'center',
        fontStyle: 'italic',
    },
    versionCard: {
        flex: 1,
        minWidth: 0,
        minHeight: 138,
        paddingHorizontal: 18,
        paddingVertical: 18,
        borderRadius: 8,
        borderWidth: 1,
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        backdropFilter: 'blur(6px)' as any,
        shadowColor: '#000',
        shadowOpacity: 0.08,
        shadowRadius: 10,
        shadowOffset: { width: 0, height: 4 },
    },
    homeActionFeatured: {
        minHeight: 154,
    },
    homeActionIcon: {
        width: 54,
        height: 54,
        borderRadius: 8,
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    homeActionArrow: {
        position: 'absolute',
        right: 16,
        bottom: 16,
        width: 40,
        height: 40,
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
    },
    versionTitle: {
        fontSize: 25,
        lineHeight: 31,
        fontFamily: 'Georgia',
        fontWeight: '700',
        textAlign: 'left',
    },
    versionSubtitle: {
        color: '#e2b13c',
        fontSize: 24,
        lineHeight: 30,
        fontWeight: '700',
        letterSpacing: 2,
        textAlign: 'center',
    },
    versionCopy: {
        marginTop: 8,
        maxWidth: 420,
        paddingRight: 42,
        fontSize: 13,
        lineHeight: 19,
        textAlign: 'left',
    },
    versionCardCopy: {
        alignItems: 'flex-start',
        marginTop: 18,
    },
    biscainhosPartners: {
        marginTop: 28,
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 28,
    },
    partnerBadge: {
        minWidth: 80,
        minHeight: 32,
        paddingHorizontal: 12,
        borderRadius: 4,
        backgroundColor: 'rgba(255,255,255,0.18)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    partnerText: {
        color: 'rgba(255,255,255,0.78)',
        fontSize: 10,
        textAlign: 'center',
    },
    copyright: {
        marginTop: 24,
        fontSize: 12,
        textAlign: 'center',
    },
});
